module.exports = __webpack_public_path__ + "static/media/img_vr_header.5177ccf4.svg";